"use client";

import MaxWidthWrapper from "@/components/shared/max-width-wrapper";
import { stats } from "@/config/landing";
import { ShieldCheck, Zap, MessageSquare, Users } from "lucide-react";
import { motion, type Variants } from "motion/react";

const STAT_ICONS = [ShieldCheck, Zap, MessageSquare, Users];

const containerVariants: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1,
    },
  },
};

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 30, filter: "blur(6px)" },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      type: "spring",
      stiffness: 120,
      damping: 20,
    },
  },
};

export default function Powered() {
  return (
    <section className="border-y border-border/40 bg-muted/20 py-12 backdrop-blur-sm dark:bg-muted/10">
      <MaxWidthWrapper>
        <motion.div
          className="grid grid-cols-2 gap-6 md:grid-cols-4 md:gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-40px" }}
        >
          {stats.map((stat, i) => {
            const Icon = STAT_ICONS[i % STAT_ICONS.length];

            return (
              <motion.div
                key={stat.label}
                variants={itemVariants}
                whileHover={{
                  y: -4,
                  scale: 1.02,
                  transition: { type: "spring", stiffness: 300, damping: 20 },
                }}
                className="group relative flex flex-col items-center text-center cursor-default p-2 rounded-2xl transition-colors "
              >
                <div className="mb-3 flex size-11 items-center justify-center rounded-xl border border-indigo-500/20 bg-indigo-500/10 text-indigo-600 shadow-sm transition-transform duration-300 group-hover:scale-110 group-hover:border-indigo-500/40 dark:border-indigo-400/20 dark:bg-indigo-950/40 dark:text-indigo-400">
                  <Icon className="size-5" />
                </div>
                <p className="font-urban text-3xl font-extrabold tracking-tight text-foreground md:text-4xl">
                  {stat.value}
                </p>
                <p className="mt-1 text-xs font-bold uppercase tracking-wider text-foreground sm:text-sm">
                  {stat.label}
                </p>
                {stat.description && (
                  <p className="mt-1 text-xs text-muted-foreground hidden sm:block">
                    {stat.description}
                  </p>
                )}
              </motion.div>
            );
          })}
        </motion.div>
      </MaxWidthWrapper>
    </section>
  );
}
